import React, { useState, useRef, useEffect } from "react";
import RichText from "../../richText/RichText";
import styled from "styled-components";
import { Col } from "react-bootstrap";
import Theme from "../../vars/ThemeOptions";
import { H4, P, PlusMinus } from "./";

const Styled = {}; 
Styled.Accordion = styled(Col)`
  & > button {
    @media screen and (max-width: ${Theme.break.md}px){
      margin-top: 4vh;
    }
    position: relative;
    width: 100%;
    display: block;
    appearance: none;
    background: none;
    border: none;
    @media screen {
      :focus {
        outline: none;
      }
    }
    h4 {
      //width: calc(100% - 3rem);
      max-width: 768px;
      margin: auto;
      display: block;
      line-height: 1;
      padding-bottom: 0.5rem;
      border-bottom: 1px solid rgb(0, 55, 152);
      margin-bottom: 0.75rem;
    }
  }
  &.shut > div {
    overflow: hidden;
    height: 0;
    position: relative;
    top: -100%;
    transition: all 0.5s ease;
  }
  &.open > div {
    overflow: hidden;
    height: auto;
    transition: all 0.5s ease;
    position: relative;
    top: 0;
  }
`;

export const Accordion = ({ title, json }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef();
  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    const handleResize = () => {
      setContentHeight(contentRef.current.offsetHeight);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [contentHeight]);
  return (
    <Styled.Accordion
      className={isOpen ? "open" : "shut"}
      xs={{ span: 10, offset: 1 }}
    >
      <button onClick={handleClick}>
        <H4 left style={{ paddingRight: "12.5%" }}>
          {title}
        </H4>

        <PlusMinus
          isOpen={isOpen}
          style={{ position: "absolute", top: 0, right: "9%", zIndex: 2 }}
          plusStyle={{ backgroundColor: Theme.hex("navy") }}
        />
      </button>
      <div style={{ height: isOpen ? contentHeight : 0 }}>
        <P left ref={contentRef} fluid>
          <RichText json={json} />
        </P>
      </div>
    </Styled.Accordion>
  );
};
